import {
  enumUnit,
  SalesItemLineType,
  Unit,
} from '@rematter/frontend-lib-api-client';

import {
  enumLoadWeightType,
  LoadFormLineItem,
} from '~/modules/trade/types/load';
import { PurchaseOrderLineItemRecord } from '~/modules/trade/types/purchaseOrder';
import { zeroMoney } from '~/modules/trade/utils/money';

export const convertToPurchaseOrderLoadFormLineItem = (
  item: PurchaseOrderLineItemRecord,
): LoadFormLineItem => ({
  id: item.id,
  type: 'Raw' as SalesItemLineType,
  itemId: item.itemId,
  tagId: null,
  unitPrice: item.unitPrice || zeroMoney(),
  estimatedPrice: undefined,
  salesOrderLineId: undefined,
  pricingUnit: (item.unit ?? enumUnit.Pounds) as Unit,
  weights: {
    [enumLoadWeightType.Gross]: null,
    [enumLoadWeightType.Tare]: null,
    [enumLoadWeightType.Net]: {
      value: item.quantity ?? 0,
      unit: (item.unit ?? enumUnit.Pounds) as Unit,
      __typename: 'Weight' as const,
    },
  },
});
